import React, { useContext } from "react";

import { Preview, TextState } from "@creatomate/preview";
import { Button } from "@culturehq/components";

import { Trans } from "app/utils";

import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";

import { deleteSection, updateSubtitleIndexesInCreatomate } from "../utils";

interface DeleteSectionProps {
  preview: Preview;
  subtitleElement: TextState;
}

const DeleteSection: React.FC<DeleteSectionProps> = ({ preview, subtitleElement }) => {
  const { data, handleUpdateData } = useContext(CreatomateContext);
  const { subtitles } = data;

  const getSectionIndex = (): number => {
    const activeSub = subtitles.find(sub => sub.active);

    const activeSections = activeSub?.sections;

    return (activeSections?.findIndex(
      as => as.creatomateId === subtitleElement.source.id)) ?? -1;
  };

  const handleAccept = async () => {
    const subtitlesWithputDeletedElement = await deleteSection(
      preview, subtitles, getSectionIndex(), handleUpdateData
    );

    // Create a new subtitles array with updated sections
    const updatedSubtitles = subtitlesWithputDeletedElement.map(subtitle => {
      const updatedSections = subtitle.sections?.map((uSec, ind) => ({ ...uSec, index: ind }));
      return { ...subtitle, sections: updatedSections };
    });
    handleUpdateData({ subtitles: updatedSubtitles });

    await updateSubtitleIndexesInCreatomate(preview, subtitles);
  };

  return (
    <ChqModalConfirmDelete
      onAccept={handleAccept}
      trigger={(onTrigger: () => void) => (
        <Button className="DeleteBtn" icon="trash-a-outlined" onClick={onTrigger} inverted />
      )}
    >
      <Trans>Are you sure you would like to delete this section?</Trans>
    </ChqModalConfirmDelete>
  );
};

export default DeleteSection;
